<app-layout preset="data">
  <app-layout-title>{{ 'PAGE_TITLES.status_history' | translate }}</app-layout-title>

  <app-layout-content>
    <app-list class="list-grid">
      <app-list-container *app-list-paginated-provider="let change of dataSource">

        <app-list-head>
          @if (change.whoChange) {
            <app-heading
              [title]="change.whoChange.fullName"
              [subtitle]="change.whoChange.username">
            </app-heading>
          } @else {
            {{ 'HISTORY.RECONCILIATION.missing' | translate }}
          }

          <app-date [date]="change.createdAt" style="text-align: right" icon="access_time"></app-date>

        </app-list-head>

        <app-list-body>
          <app-scrollable-list [count]="change.groups.length">
            <div class="body-grid">
              @if (statuses$ | async; as statuses) {
                @for (group of change.groups; track group) {
                  <a
                    [project-route]="['history/statuses', change.id, group.id]"
                    class="change">
                    <div class="from" [matTooltip]="$safeNavigationMigration(statuses[group.fromStatusId]?.name)">
                      {{ statuses[group.fromStatusId]?.name || ('COMMON.not_found' | translate)  }}
                    </div>
                    <div class="arrow-wrapper">
                      <div class="arrow">
                        <span class="up"></span>
                        <span class="down"></span>
                      </div>
                      <span>{{ group.count }}</span>
                    </div>
                    <div class="to" [matTooltip]="$safeNavigationMigration(statuses[group.toStatusId]?.name)">
                      {{ statuses[group.toStatusId]?.name || ('COMMON.not_found' | translate) }}
                    </div>
                  </a>
                }
              }
            </div>
          </app-scrollable-list>
        </app-list-body>

        <app-list-actions>
          <a [project-route]="['history/statuses', change.id]" color="primary" mat-button>
            <mat-icon style="margin-right: 5px;">info_outline</mat-icon>
            <mat-label>{{ 'HISTORY.UNLOADING.open' | translate }}</mat-label>
          </a>
        </app-list-actions>

      </app-list-container>
    </app-list>
  </app-layout-content>
</app-layout>
